import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

import Visibility from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { useStyles } from "./LoginForm.css";
import FormLoader from "../../../../../Component/FormLoader/FormLoader";

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
    };
  }

  showPassword = () => {
    return (
      <Visibility
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showPassword: true })}
      />
    );
  };

  hidePassword = () => {
    return (
      <VisibilityOffIcon
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showPassword: false })}
      />
    );
  };

  render() {
    const { classes } = this.props;
    return (
      <form onSubmit={this.props.handleSubmit}>
        <Typography variant="h5" className={classes.title}>
          <div>{this.props.label}</div>
          <div>
            <strong>Login</strong>
          </div>
        </Typography>
        <TextField
          name="email"
          type="email"
          label="Email"
          fullWidth
          required
          margin="normal"
          variant="outlined"
          placeholder="Enter email"
          error={this.props.error.emailError ? true : false}
          helperText={this.props.error.emailError}
          style={{ outline: "none" }}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={this.props.data.email}
          onChange={this.props.handleChange}
        />

        <TextField
          name="password"
          type={this.state.showPassword ? "text" : "password"}
          label="Password"
          fullWidth
          required
          margin="normal"
          variant="outlined"
          placeholder="Enter password"
          error={this.props.error.passwordError ? true : false}
          helperText={this.props.error.passwordError}
          style={{ outline: "none" }}
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline,
              focused: classes.focused,
            },
            endAdornment: this.state.showPassword
              ? this.hidePassword()
              : this.showPassword(),
          }}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot,
              focused: classes.labelFocused,
            },
            shrink: true,
          }}
          value={this.props.data.password}
          onChange={this.props.handleChange}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            type="submit"
            variant="outlined"
            className={classes.buttonStyle}
          >
            Login
          </Button>
          {this.props.loading && <FormLoader />}
          <div
            style={{
              marginLeft: 10,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Link to={this.props.passwordRecoverUrl}>Forgot password?</Link>
          </div>
        </div>
      </form>
    );
  }
}

export default withStyles(useStyles)(LoginForm);
